<template>
	<div
		ref="planning_grid"
		class="planning-grid">
		<Planning
			v-for="(planning, index) in plannings"
			:key="planning.id"
			:id="planning.id"
			:title="planning.Info.title"
			:icon="planning.Info.icon"
			:owner="planning.User"
			:tasks="planning.Tasks"
			:style="{'margin-right': getMargin(index), 'width': width}">
		</Planning>
	</div>
</template>

<script>
import Planning from '@/components/Planning.vue'
export default {
	components: {
		Planning
	},
	props: {
		plannings: Array
	},
	data () {
		return {
			spacing: 24,
			rowAmount: 0,
			margin: 0,
			width: 0
		}
	},
	methods: {
		getMargin (index) {
			if ((index + 1) % this.rowAmount !== 0) return this.spacing + 'px'
			else return 0
		},
		handleResize () {
			let width = 0
			let minWidth = 320
			// Don't limit this for now
			let maxWidth = 9999
			this.$nextTick(() => {
				let parentStyle = window.getComputedStyle(this.$refs.planning_grid)
				let parentWidth = this.$refs.planning_grid.clientWidth - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight)
				this.rowAmount = Math.floor((parentWidth + this.spacing) / (minWidth + this.spacing))
				width = Math.min((parentWidth - ((this.rowAmount - 1) * this.spacing)) / this.rowAmount, maxWidth)
				if ((width + this.spacing) * this.rowAmount - this.spacing < parentWidth) width = minWidth
				this.width = width + 'px'
			})
		}
	},
	mounted () {
		this.handleResize()
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>

<style lang="scss" scoped>
</style>
